"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6618],{

/***/ "./node_modules/@chakra-ui/form-control/dist/index.esm.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J1": function() { return /* binding */ FormErrorMessage; },
/* harmony export */   "Kn": function() { return /* binding */ useFormControlProps; },
/* harmony export */   "NI": function() { return /* binding */ FormControl; },
/* harmony export */   "Yp": function() { return /* binding */ useFormControl; },
/* harmony export */   "lX": function() { return /* binding */ FormLabel; }
/* harmony export */ });
/* unused harmony exports FormErrorIcon, FormHelperText, RequiredIndicator, useFormControlContext, useFormControlStyles, useFormErrorStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@chakra-ui/react-context/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react_use_merge_refs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/react-use-merge-refs/dist/index.esm.js");
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/@chakra-ui/styled-system/dist/index.esm.js");
/* harmony import */ var _chakra_ui_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
// ../../../react-shim.js


// src/form-control.tsx




// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
var dataAttr = (condition) => condition ? "" : void 0;
var ariaAttr = (condition) => condition ? true : void 0;
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}

// src/form-control.tsx

var [FormControlStylesProvider, useFormControlStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  name: `FormControlStylesContext`,
  errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
});
var [FormControlProvider, useFormControlContext] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  strict: false,
  name: "FormControlContext"
});
function useFormControlProvider(props) {
  const {
    id: idProp,
    isRequired,
    isInvalid,
    isDisabled,
    isReadOnly,
    ...htmlProps
  } = props;
  const uuid = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
  const id = idProp || `field-${uuid}`;
  const labelId = `${id}-label`;
  const feedbackId = `${id}-feedback`;
  const helpTextId = `${id}-helptext`;
  const [hasFeedbackText, setHasFeedbackText] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [hasHelpText, setHasHelpText] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [isFocused, setFocus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const getHelpTextProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((props2 = {}, forwardedRef = null) => ({
    id: helpTextId,
    ...props2,
    ref: (0,_chakra_ui_react_use_merge_refs__WEBPACK_IMPORTED_MODULE_2__/* .mergeRefs */ .lq)(forwardedRef, (node) => {
      if (!node)
        return;
      setHasHelpText(true);
    })
  }), [helpTextId]);
  const getLabelProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((props2 = {}, forwardedRef = null) => ({
    ...props2,
    ref: forwardedRef,
    "data-focus": dataAttr(isFocused),
    "data-disabled": dataAttr(isDisabled),
    "data-invalid": dataAttr(isInvalid),
    "data-readonly": dataAttr(isReadOnly),
    id: props2.id ?? labelId,
    htmlFor: props2.htmlFor ?? id
  }), [id, isDisabled, isFocused, isInvalid, isReadOnly, labelId]);
  const getErrorMessageProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((props2 = {}, forwardedRef = null) => ({
    id: feedbackId,
    ...props2,
    ref: (0,_chakra_ui_react_use_merge_refs__WEBPACK_IMPORTED_MODULE_2__/* .mergeRefs */ .lq)(forwardedRef, (node) => {
      if (!node)
        return;
      setHasFeedbackText(true);
    }),
    "aria-live": "polite"
  }), [feedbackId]);
  const getRootProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((props2 = {}, forwardedRef = null) => ({
    ...props2,
    ...htmlProps,
    ref: forwardedRef,
    role: "group"
  }), [htmlProps]);
  const getRequiredIndicatorProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((props2 = {}, forwardedRef = null) => ({
    ...props2,
    ref: forwardedRef,
    role: "presentation",
    "aria-hidden": true,
    children: props2.children || "*"
  }), []);
  return {
    isRequired: !!isRequired,
    isInvalid: !!isInvalid,
    isReadOnly: !!isReadOnly,
    isDisabled: !!isDisabled,
    isFocused: !!isFocused,
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    hasFeedbackText,
    setHasFeedbackText,
    hasHelpText,
    setHasHelpText,
    id,
    labelId,
    feedbackId,
    helpTextId,
    htmlProps,
    getHelpTextProps,
    getErrorMessageProps,
    getRootProps,
    getLabelProps,
    getRequiredIndicatorProps
  };
}
var FormControl = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .Gp)(function FormControl2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useMultiStyleConfig */ .jC)("Form", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .omitThemingProps */ .Lr)(props);
  const {
    getRootProps,
    htmlProps: _,
    ...context
  } = useFormControlProvider(ownProps);
  const className = cx("chakra-form-control", props.className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FormControlProvider, {
    value: context
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FormControlStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.div */ .m$.div, {
    ...getRootProps({}, ref),
    className,
    __css: styles["container"]
  })));
});
FormControl.displayName = "FormControl";
var FormHelperText = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .Gp)(function FormHelperText2(props, ref) {
  const field = useFormControlContext();
  const styles = useFormControlStyles();
  const className = cx("chakra-form__helper-text", props.className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.div */ .m$.div, {
    ...field == null ? void 0 : field.getHelpTextProps(props, ref),
    __css: styles.helperText,
    className
  });
});
FormHelperText.displayName = "FormHelperText";

// src/use-form-control.ts
function useFormControl(props) {
  const { isDisabled, isInvalid, isReadOnly, isRequired, ...rest } = useFormControlProps(props);
  return {
    ...rest,
    disabled: isDisabled,
    readOnly: isReadOnly,
    required: isRequired,
    "aria-invalid": ariaAttr(isInvalid),
    "aria-required": ariaAttr(isRequired),
    "aria-readonly": ariaAttr(isReadOnly)
  };
}
function useFormControlProps(props) {
  const field = useFormControlContext();
  const {
    id,
    disabled,
    readOnly,
    required,
    isRequired,
    isInvalid,
    isReadOnly,
    isDisabled,
    onFocus,
    onBlur,
    ...rest
  } = props;
  const labelIds = props["aria-describedby"] ? [props["aria-describedby"]] : [];
  if ((field == null ? void 0 : field.hasFeedbackText) && (field == null ? void 0 : field.isInvalid)) {
    labelIds.push(field.feedbackId);
  }
  if (field == null ? void 0 : field.hasHelpText) {
    labelIds.push(field.helpTextId);
  }
  return {
    ...rest,
    "aria-describedby": labelIds.join(" ") || void 0,
    id: id ?? (field == null ? void 0 : field.id),
    isDisabled: disabled ?? isDisabled ?? (field == null ? void 0 : field.isDisabled),
    isReadOnly: readOnly ?? isReadOnly ?? (field == null ? void 0 : field.isReadOnly),
    isRequired: required ?? isRequired ?? (field == null ? void 0 : field.isRequired),
    isInvalid: isInvalid ?? (field == null ? void 0 : field.isInvalid),
    onFocus: callAllHandlers(field == null ? void 0 : field.onFocus, onFocus),
    onBlur: callAllHandlers(field == null ? void 0 : field.onBlur, onBlur)
  };
}

// src/form-error.tsx



var [FormErrorStylesProvider, useFormErrorStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  name: `FormErrorStylesContext`,
  errorMessage: `useFormErrorStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormError />" `
});
var FormErrorMessage = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useMultiStyleConfig */ .jC)("FormError", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .omitThemingProps */ .Lr)(props);
  const field = useFormControlContext();
  if (!(field == null ? void 0 : field.isInvalid))
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FormErrorStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.div */ .m$.div, {
    ...field == null ? void 0 : field.getErrorMessageProps(ownProps, ref),
    className: cx("chakra-form__error-message", props.className),
    __css: {
      display: "flex",
      alignItems: "center",
      ...styles.text
    }
  }));
});
FormErrorMessage.displayName = "FormErrorMessage";
var FormErrorIcon = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = useFormErrorStyles();
  const field = useFormControlContext();
  if (!(field == null ? void 0 : field.isInvalid))
    return null;
  const _className = cx("chakra-form__error-icon", props.className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_icon__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
    ref,
    "aria-hidden": true,
    ...props,
    __css: styles.icon,
    className: _className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "currentColor",
    d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
  }));
});
FormErrorIcon.displayName = "FormErrorIcon";

// src/form-label.tsx

var FormLabel = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .Gp)(function FormLabel2(passedProps, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useStyleConfig */ .mq)("FormLabel", passedProps);
  const props = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .omitThemingProps */ .Lr)(passedProps);
  const {
    className,
    children,
    requiredIndicator = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RequiredIndicator, null),
    optionalIndicator = null,
    ...rest
  } = props;
  const field = useFormControlContext();
  const ownProps = (field == null ? void 0 : field.getLabelProps(rest, ref)) ?? { ref, ...rest };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.label */ .m$.label, {
    ...ownProps,
    className: cx("chakra-form__label", props.className),
    __css: {
      display: "block",
      textAlign: "start",
      ...styles
    }
  }, children, (field == null ? void 0 : field.isRequired) ? requiredIndicator : optionalIndicator);
});
FormLabel.displayName = "FormLabel";
var RequiredIndicator = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .Gp)(function RequiredIndicator2(props, ref) {
  const field = useFormControlContext();
  const styles = useFormControlStyles();
  if (!(field == null ? void 0 : field.isRequired))
    return null;
  const className = cx("chakra-form__required-indicator", props.className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.span */ .m$.span, {
    ...field == null ? void 0 : field.getRequiredIndicatorProps(props, ref),
    __css: styles.requiredIndicator,
    className
  });
});
RequiredIndicator.displayName = "RequiredIndicator";



/***/ }),

/***/ "./src/components/Elements/Avatar/DisplayAvatar.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var boring_avatars__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/boring-avatars/build/index.js");
/* harmony import */ var boring_avatars__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(boring_avatars__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./node_modules/@chakra-ui/avatar/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _data_AvatarData__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/data/AvatarData.ts");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
/* harmony import */ var _hooks_useENSData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/hooks/useENSData.ts");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/config/index.ts");
/* harmony import */ var _services_profile_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/services/profile/utils.ts");
/* harmony import */ var _Image_Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/components/Elements/Image/Image.tsx");










const DisplayAvatar = (param)=>{
    let { address , svgProps , avatarIPFS , wrapperProps , size =26 , alt , ...rest } = param;
    const [avatar] = (0,_hooks_useENSData__WEBPACK_IMPORTED_MODULE_3__/* .useENSData */ .L)(address);
    const { avatar: fetchedAvatarIPFS , setAccount  } = (0,_services_profile_utils__WEBPACK_IMPORTED_MODULE_5__/* .useUserProfileData */ .Cf)(_services_profile_utils__WEBPACK_IMPORTED_MODULE_5__/* .UserProfileFetchOptions.ONLY_AVATAR */ .Ky.ONLY_AVATAR);
    let content = null;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (address && !avatarIPFS) {
            setAccount(address);
        }
    }, [
        address,
        avatarIPFS,
        setAccount
    ]);
    if (avatarIPFS || fetchedAvatarIPFS) {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image_Image__WEBPACK_IMPORTED_MODULE_6__/* .Image */ .E, {
            imgBoxSize: size,
            src: "".concat(_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].pinataBaseUrl */ .Z.pinataBaseUrl).concat(avatarIPFS || fetchedAvatarIPFS),
            borderRadius: "full",
            ...rest,
            alt: alt || "Avatar"
        });
    } else if (avatar) {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Avatar */ .qE, {
            boxSize: "".concat(size, "px"),
            src: avatar,
            name: alt,
            ...rest
        });
    } else if (address && !avatar) {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((boring_avatars__WEBPACK_IMPORTED_MODULE_2___default()), {
            size: size,
            variant: "pixel",
            name: address,
            colors: _data_AvatarData__WEBPACK_IMPORTED_MODULE_8__/* .AvatarColorArray */ .M
        });
    } else {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Icon */ .JO, {
            cursor: "pointer",
            fontSize: size,
            color: "gray.600",
            _dark: {
                color: "gray.200"
            },
            fontWeight: 600,
            as: react_icons_ri__WEBPACK_IMPORTED_MODULE_10__/* .RiUserLine */ .s60,
            title: alt
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Center */ .M5, {
        ...wrapperProps,
        sx: {
            svg: {
                ...svgProps
            }
        },
        borderRadius: "full",
        children: content
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DisplayAvatar);


/***/ }),

/***/ "./src/components/Elements/Image/Image.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* unused harmony export cfLoader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/next/image.js");
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




const BASE_URL = "https://iq.wiki";
const cfLoader = (param)=>{
    let { src , width , quality  } = param;
    const params = [
        "width=".concat(width)
    ];
    if (quality) params.push("quality=".concat(quality));
    const paramsString = params.join(",");
    return "".concat(BASE_URL, "/cdn-cgi/image/").concat(paramsString, "/").concat(normalizeSrc(src));
};
const normalizeSrc = (src)=>{
    return src.startsWith("/") ? src.slice(1) : src;
};
const Image = (param)=>/*#__PURE__*/ {
    let { src , alt , priority , placeholder , blurDataURL , hideOnError , sizes , objectFit ="cover" , imgBoxSize , imgW , imgH , ...rest } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        h: "".concat(imgBoxSize || imgH, "px"),
        w: "".concat(imgBoxSize || imgW, "px"),
        ...rest,
        overflow: "hidden",
        position: "relative",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            quality: 95,
            style: {
                objectFit,
                objectPosition: "top",
                width: "100%",
                height: "100%"
            },
            loader: typeof src === "string" && src.startsWith("http") ? cfLoader : undefined,
            fill: !(imgW && imgH) || !imgBoxSize,
            src: src,
            alt: alt,
            onError: (e)=>{
                if (hideOnError) {
                    e.currentTarget.style.visibility = "hidden";
                }
            },
            priority: priority,
            sizes: sizes,
            placeholder: placeholder,
            blurDataURL: blurDataURL,
            loading: priority ? "eager" : "lazy",
            width: imgBoxSize || imgW,
            height: imgBoxSize || imgH
        })
    });
};


/***/ }),

/***/ "./src/components/Layout/Navbar/ColorModeToggle.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ ColorModeToggle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/system/node_modules/@chakra-ui/color-mode/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/@chakra-ui/menu/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./node_modules/@chakra-ui/switch/dist/index.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/react-icons/fa/index.esm.js");




const ColorModeToggle = (param)=>{
    let { isInMobileMenu  } = param;
    const { colorMode , toggleColorMode  } = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useColorMode */ .If)();
    const ColorModeIcon = colorMode === "light" ? react_icons_fa__WEBPACK_IMPORTED_MODULE_3__/* .FaMoon */ .TLr : react_icons_fa__WEBPACK_IMPORTED_MODULE_3__/* .FaSun */ .Mei;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .MenuItem */ .sN, {
            minH: "48px",
            px: isInMobileMenu ? 0 : 3,
            bgColor: !isInMobileMenu ? "subMenuBg" : "transparent",
            sx: {
                "&:hover, &:active, &:focus": {
                    bgColor: !isInMobileMenu ? "subMenuHoverBg" : "transparent"
                }
            },
            onClick: toggleColorMode,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                    cursor: "pointer",
                    fontSize: "4xl",
                    color: "linkColor",
                    fontWeight: 600,
                    as: ColorModeIcon,
                    pr: 3
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                    ml: isInMobileMenu ? 2 : "unset",
                    fontSize: "md",
                    fontWeight: "semibold",
                    color: "linkColor",
                    flex: "auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: isInMobileMenu ? {
                                fontSize: 18
                            } : {},
                            children: "Night Mode"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Switch */ .r, {
                            ml: "auto",
                            isChecked: colorMode === "dark",
                            pointerEvents: "none"
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ "./src/components/Layout/Navbar/Logout.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ LogOutBtn; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _store_slices_user_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/store/slices/user-slice.ts");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./node_modules/@chakra-ui/menu/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/next/router.js");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./node_modules/wagmi/dist/index.js");








const LogOutBtn = (param)=>{
    let { isInMobileMenu  } = param;
    const { isConnected: isUserConnected  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useAccount */ .mA)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    const { disconnect  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useDisconnect */ .qL)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const handleLogOut = ()=>{
        disconnect();
        dispatch((0,_store_slices_user_slice__WEBPACK_IMPORTED_MODULE_1__/* .setStateToDefault */ .GJ)());
        window.localStorage.removeItem("USER_TOKEN");
        router.push(router.asPath);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .MenuItem */ .sN, {
                minH: "48px",
                borderTopWidth: isInMobileMenu ? 0 : "1px",
                px: isInMobileMenu ? 0 : 3,
                bgColor: !isInMobileMenu ? "subMenuBg" : "transparent",
                sx: {
                    "&:hover, &:focus, &:active": {
                        bgColor: "subMenuHoverBg"
                    }
                },
                onClick: isUserConnected ? handleLogOut : undefined,
                cursor: isUserConnected ? "pointer" : "not-allowed",
                display: isUserConnected ? "flex" : "none",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO, {
                        fontSize: "4xl",
                        color: "linkColor",
                        fontWeight: 600,
                        as: react_icons_ri__WEBPACK_IMPORTED_MODULE_9__/* .RiLogoutBoxRFill */ .goJ,
                        pr: 3
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                        ml: isInMobileMenu ? 2 : "unset",
                        fontSize: "md",
                        fontWeight: "semibold",
                        color: "linkColor",
                        flex: "auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: isInMobileMenu ? {
                                fontSize: 18
                            } : {},
                            children: "Log out"
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ "./src/components/Layout/Navbar/ProfileNavItem.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProfileNavItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./src/components/Elements/Avatar/DisplayAvatar.tsx
var DisplayAvatar = __webpack_require__("./src/components/Elements/Avatar/DisplayAvatar.tsx");
// EXTERNAL MODULE: ./src/data/NavItemData.ts
var NavItemData = __webpack_require__("./src/data/NavItemData.ts");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./src/utils/WalletUtils/getUserAddressFromCache.ts
var getUserAddressFromCache = __webpack_require__("./src/utils/WalletUtils/getUserAddressFromCache.ts");
// EXTERNAL MODULE: ./src/components/Layout/Navbar/ColorModeToggle.tsx
var ColorModeToggle = __webpack_require__("./src/components/Layout/Navbar/ColorModeToggle.tsx");
// EXTERNAL MODULE: ./src/components/Layout/Navbar/NavMenu.tsx
var NavMenu = __webpack_require__("./src/components/Layout/Navbar/NavMenu.tsx");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/menu/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("./node_modules/next/router.js");
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Layout/Navbar/ProfileLink.tsx






const ProfileLink = ()=>{
    const userAddress = (0,getUserAddressFromCache/* getUserAddressFromCache */.X)();
    const router = (0,next_router.useRouter)();
    const [link, setLink] = (0,react.useState)(userAddress ? "/account/".concat(userAddress) : "/login");
    (0,react.useEffect)(()=>{
        setLink(userAddress ? "/account/".concat(userAddress) : "/login");
    }, [
        userAddress
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* MenuItem */.sN, {
        order: -1,
        onClick: ()=>router.push(link),
        minH: "48px",
        bg: "subMenuBg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                cursor: "pointer",
                fontSize: "4xl",
                fontWeight: 600,
                as: ri_index_esm/* RiAccountCircleFill */.RrS,
                color: "linkColor",
                pr: 3
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                fontSize: "md",
                fontWeight: 600,
                color: "linkColor",
                children: "Profile"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Layout/Navbar/Logout.tsx
var Logout = __webpack_require__("./src/components/Layout/Navbar/Logout.tsx");
;// CONCATENATED MODULE: ./src/components/Layout/Navbar/ProfileNavItem.tsx










const ProfileNavMenu = (param)=>{
    let { setVisibleMenu , visibleMenu  } = param;
    const userAddress = (0,getUserAddressFromCache/* getUserAddressFromCache */.X)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        onMouseLeave: ()=>setVisibleMenu(null),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavMenu/* default */.Z, {
            navItem: NavItemData/* NAV_ICON */.Di,
            setVisibleMenu: setVisibleMenu,
            visibleMenu: visibleMenu,
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAvatar/* default */.Z, {
                address: userAddress,
                size: 25,
                alt: userAddress
            }, userAddress),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileLink, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorModeToggle/* ColorModeToggle */.c, {
                    isInMobileMenu: false
                }),
                userAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logout/* LogOutBtn */.W, {
                    isInMobileMenu: false
                })
            ]
        })
    });
};
/* harmony default export */ var ProfileNavItem = (ProfileNavMenu);


/***/ }),

/***/ "./src/data/AvatarData.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ AvatarColorArray; }
/* harmony export */ });
const AvatarColorArray = [
    "#92A1C6",
    "#146A7C",
    "#F0AB3D",
    "#C271B4",
    "#C20D90"
];


/***/ }),

/***/ "./src/hooks/useENSData.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useENSData; }
/* harmony export */ });
/* harmony import */ var _services_ens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/services/ens/index.ts");
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/store/store.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/react/index.js");



const useENSData = (address, skip)=>{
    const [avatar, setAvatar] = react__WEBPACK_IMPORTED_MODULE_2__.useState("");
    const [displayName, setDisplayName] = react__WEBPACK_IMPORTED_MODULE_2__.useState("");
    const [loading, setLoading] = react__WEBPACK_IMPORTED_MODULE_2__.useState(false);
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(()=>{
        if (!address || skip) return;
        const fetchEnsData = async ()=>{
            setLoading(true);
            const { data  } = await _store_store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch(_services_ens__WEBPACK_IMPORTED_MODULE_0__/* .getEns.initiate */ .gS.initiate(address.toLowerCase()));
            if (data) {
                setAvatar(data.avatar);
                setDisplayName((p)=>data.displayName.endsWith(".eth") ? data.displayName : p);
            }
            setLoading(false);
        };
        fetchEnsData();
    }, [
        address,
        skip
    ]);
    return [
        avatar,
        displayName,
        loading
    ];
};


/***/ }),

/***/ "./src/services/profile/utils.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ useUserProfileData; },
/* harmony export */   "Ky": function() { return /* binding */ UserProfileFetchOptions; },
/* harmony export */   "oN": function() { return /* binding */ isUserNameTaken; }
/* harmony export */ });
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/store/store.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/services/profile/index.tsx");



var UserProfileFetchOptions;
(function(UserProfileFetchOptions) {
    UserProfileFetchOptions[UserProfileFetchOptions["WITH_ALL_SETTINGS"] = 0] = "WITH_ALL_SETTINGS";
    UserProfileFetchOptions[UserProfileFetchOptions["ONLY_EMAIL"] = 1] = "ONLY_EMAIL";
    UserProfileFetchOptions[UserProfileFetchOptions["ONLY_AVATAR"] = 2] = "ONLY_AVATAR";
    UserProfileFetchOptions[UserProfileFetchOptions["USER_PROFILE"] = 3] = "USER_PROFILE";
})(UserProfileFetchOptions || (UserProfileFetchOptions = {}));
const useUserProfileData = (options, address)=>{
    const [profileData, setProfileData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [avatar, setAvatar] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [account, setAccount] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(address || "");
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!account) return;
        const fetchSettings = async ()=>{
            try {
                if (options === UserProfileFetchOptions.WITH_ALL_SETTINGS) {
                    const { data: fetchedProfileData  } = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUserSettings.initiate */ .nS.initiate(account));
                    setProfileData(fetchedProfileData);
                } else if (options === UserProfileFetchOptions.ONLY_AVATAR) {
                    const { data: fetchedUserProfileAvatar  } = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUserAvatar.initiate */ .Dm.initiate(account));
                    setAvatar(fetchedUserProfileAvatar);
                } else if (options === UserProfileFetchOptions.ONLY_EMAIL) {
                    const { data: fetchedProfileData1  } = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUserEmail.initiate */ .gV.initiate(account));
                    setProfileData(fetchedProfileData1);
                } else if (options === UserProfileFetchOptions.USER_PROFILE) {
                    const { data: fetchedProfileData2  } = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUserProfile.initiate */ .et.initiate(account));
                    setProfileData(fetchedProfileData2);
                }
                setLoading(false);
            } catch (_err) {
                setLoading(false);
            }
        };
        fetchSettings();
    }, [
        account,
        options
    ]);
    return {
        setAccount,
        profileData,
        loading,
        avatar
    };
};
const isUserNameTaken = async (username)=>{
    const { data  } = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUsernameTaken.initiate */ .l4.initiate(username));
    return data;
};


/***/ })

}]);